import { post } from '@/request/http';

const CheckAmount = {
  // 获取手机验证码
  getSms(params) {
    return post('/backloansuper/loan/supermarket/sms/v1.0', params);
  },
  insertLoanTestInfo(params) {
    return post(
      '/backloansuper/loan/supermarket/test/insertLoanTestInfo',
      params,
    );
  },
};
export default CheckAmount;
